export default __webpack_public_path__ + "static/media/notice-icon.1bc5b6fe.svg";